export type GlobalNavRemoteEvent = CustomEvent<
  | RemotePayload<RemoteEvent.AUTH_REQUEST_LOGOUT>
  | RemotePayload<RemoteEvent.AUTH_REQUEST_SSI>
  | RemotePayload<RemoteEvent.INIT_COMPLETED>
  | RemotePayload<RemoteEvent.NAVIGATION_REQUEST>
  | RemotePayload<RemoteEvent.SEARCH_REQUEST>
  | RemotePayload<RemoteEvent.SUBNAV_ACTION_REQUEST>
>;

type RemotePayload<T extends RemoteEvent> = { _payload: RemoteEventPayloads[T]; _timestamp: number; _type: T };

export enum RemoteEvent {
  AUTH_REQUEST_LOGOUT = "AUTH_REQUEST_LOGOUT",
  AUTH_REQUEST_SSI = "AUTH_REQUEST_SSI",
  INIT_COMPLETED = "INIT_COMPLETED",
  NAVIGATION_REQUEST = "NAVIGATION_REQUEST",
  SEARCH_REQUEST = "SEARCH_REQUEST",
  SUBNAV_ACTION_REQUEST = "SUBNAV_ACTION_REQUEST",
}

export type RemoteEventPayloads = {
  [RemoteEvent.AUTH_REQUEST_LOGOUT]: never;
  [RemoteEvent.AUTH_REQUEST_SSI]: never;
  [RemoteEvent.INIT_COMPLETED]: never;
  [RemoteEvent.NAVIGATION_REQUEST]: NavigationModel;
  [RemoteEvent.SEARCH_REQUEST]: { platform: GlobalNavSearchPlatform; query: string };
  [RemoteEvent.SUBNAV_ACTION_REQUEST]: { value: string };
};

type NavigationModel = {
  isExternal: boolean;
  label: string;
  path: string;
  target: "_blank" | "_self";
  type: number;
  typeString: string;
};

type GlobalNavSearchPlatform = "PUBLIC_SITE" | "TOPLINK" | "SI";
